/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EmployeePayPeriodListResponse } from '../api-models';
// @ts-ignore
import { EmployeeRequestHistoryResponse } from '../api-models';
// @ts-ignore
import { EmployeeSchedulesView } from '../api-models';
// @ts-ignore
import { MobileNotificationCountsResponseV2 } from '../api-models';
// @ts-ignore
import { MobilePunchRequestV2 } from '../api-models';
// @ts-ignore
import { MobilePunchResponseV2 } from '../api-models';
// @ts-ignore
import { MobileSettingsResponseV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { UpdateMobileSettingsRequestV2 } from '../api-models';
/**
 * MobileV2Api - axios parameter creator
 * @export
 */
export const MobileV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the aggregated notification-badge counts for the logged-in employee. Today this is the  count of unresolved \"Missing Punch\" exceptions within the employee\'s currently unclosed pay  periods (closed pay periods are excluded so already-locked history does not keep the badge lit).  New counts are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileNotificationCountsResponseV2  and populated here from their own domain service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileNotificationCountsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/notification-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   <b>Date range</b>: when `startDate`/`endDate` are omitted all periods                      for the employee are eligible (subject to pagination). When provided, only periods                      whose date range overlaps the filter are included (period.EndDate >= startDate                      AND period.StartDate <= endDate).    <b>Pagination</b>: `page` is 1-based (default 1); `pageSize` defaults to                      20 and is capped at 100. `TotalCount` in the response reflects the unfiltered                      row count so the caller can derive the total number of pages.    <b>IsLocked</b>: true when the pay period is closed (`IsClosed == true`) or                      any approval level has been recorded for the period. Desktop-held employee locks                      are not checked — mobile self-service callers are not subject to desktop                      concurrency locks.
         * @summary Returns a paginated list of pay periods for the logged-in employee, each including date  range, lock/approval status, missing punch count, and an hours breakdown by pay type  (SPD-5399 pay-period list feature). The breakdown mirrors the pay-period summary view  available on desktop: rows are grouped by pay type and department labor level, ordered  by `PayTypeSortOrder`. Periods are returned newest-first.
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobilePayPeriodsGet: async (startDate?: string, endDate?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/pay-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Records a \"swipe and go\" clock in/out punch for the logged-in employee (SPD-5603) —  no punch type is accepted from the client; the calculation pipeline\'s existing  SwipeAndGo pairing derives in/out/break from the punch sequence, same as a physical  time clock. The timestamp is always the server\'s clock, never a client-supplied time;  what the client chooses is the zone: the facility\'s wall-clock time, or (SPD-6157)  the employee\'s own wall-clock time when the optional body carries  OpenShifts.BusinessObjects.Request.Mobile.MobilePunchRequestV2.UtcOffsetMinutes, the client\'s current UTC offset.  A remote employee in Israel who punches at 14:00 Israel time is then recorded at  14:00, not at the facility\'s 07:00, and the time card shows that time without any  conversion. No body and `{}` (what the mobile app sends) keep the facility clock.  The zone is taken at the client\'s word (quarter-hour offsets within UTC-12:00 to  UTC+14:00), so a client that misreports it moves its own punch by that much; the  ticket takes the employee\'s clock as the source. Requires the facility\'s  `EnableAppPunching` configuration  to be on AND the employee to be individually eligible: either the explicit  per-employee app-punching toggle, or (SPD-5774) a punch email on file on the Clock  Info tab, is sufficient for the second part.
         * @param {MobilePunchRequestV2} [mobilePunchRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobilePunchPost: async (mobilePunchRequestV2?: MobilePunchRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/punch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mobilePunchRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **type** — discriminates the request kind:  | Value | Meaning |  |-------|---------|  | 1 | MissingPunch — employee reported a missing clock-in/out |  | 2 | PunchTimeChange — employee requested a correction to an existing punch |                **status** — current approval state:  | Value | Meaning |  |-------|---------|  | 0 | Pending — awaiting manager review |  | 1 | Accepted — manager approved |  | 2 | Rejected — manager rejected |
         * @summary Returns one page of punch-time-change and missing-punch requests the logged-in  employee has submitted, ordered newest-first (SPD-5408).
         * @param {number} [page] 1-based page number (default 1, min 1).
         * @param {number} [pageSize] Number of items per page (default 20, range 1–100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileRequestHistoryGet: async (page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/request-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the logged-in employee\'s mobile app settings (SPD-5409): the upcoming-shift  reminder toggle and the reminder lead time in minutes. When the employee has never  saved the screen, reminders default to ENABLED (opt-out) and the lead falls back to  the facility\'s ShiftStartNotificationBeforeMinutes configuration (code default 30).  New settings are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileSettingsResponseV2.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves the logged-in employee\'s mobile app settings. The payload travels in the mobile  `{\"body\":{...}}` envelope; omitted fields keep their stored values, so a partial  save can never silently reset a sibling setting.
         * @param {UpdateMobileSettingsRequestV2} [updateMobileSettingsRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileSettingsPut: async (updateMobileSettingsRequestV2?: UpdateMobileSettingsRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMobileSettingsRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the logged-in employee\'s next upcoming scheduled shift so they know when and  where they work next (SPD-5399). The shape is the same OpenShifts.BusinessObjects.ViewModels.EmployeeSchedulesView  the mobile \"My Shifts\" feature (`GET /employee/v2/work-schedules-in-range`) returns,  so the app reuses its existing shift model. Serves both the V2 and legacy schedulers.  `Location` is null when the facility\'s ShowLocationOnShifts setting is off (SPD-6134).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileUpcomingShiftGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mobile/upcoming-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileV2Api - functional programming interface
 * @export
 */
export const MobileV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the aggregated notification-badge counts for the logged-in employee. Today this is the  count of unresolved \"Missing Punch\" exceptions within the employee\'s currently unclosed pay  periods (closed pay periods are excluded so already-locked history does not keep the badge lit).  New counts are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileNotificationCountsResponseV2  and populated here from their own domain service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileNotificationCountsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileNotificationCountsResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileNotificationCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *   <b>Date range</b>: when `startDate`/`endDate` are omitted all periods                      for the employee are eligible (subject to pagination). When provided, only periods                      whose date range overlaps the filter are included (period.EndDate >= startDate                      AND period.StartDate <= endDate).    <b>Pagination</b>: `page` is 1-based (default 1); `pageSize` defaults to                      20 and is capped at 100. `TotalCount` in the response reflects the unfiltered                      row count so the caller can derive the total number of pages.    <b>IsLocked</b>: true when the pay period is closed (`IsClosed == true`) or                      any approval level has been recorded for the period. Desktop-held employee locks                      are not checked — mobile self-service callers are not subject to desktop                      concurrency locks.
         * @summary Returns a paginated list of pay periods for the logged-in employee, each including date  range, lock/approval status, missing punch count, and an hours breakdown by pay type  (SPD-5399 pay-period list feature). The breakdown mirrors the pay-period summary view  available on desktop: rows are grouped by pay type and department labor level, ordered  by `PayTypeSortOrder`. Periods are returned newest-first.
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobilePayPeriodsGet(startDate?: string, endDate?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeePayPeriodListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobilePayPeriodsGet(startDate, endDate, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Records a \"swipe and go\" clock in/out punch for the logged-in employee (SPD-5603) —  no punch type is accepted from the client; the calculation pipeline\'s existing  SwipeAndGo pairing derives in/out/break from the punch sequence, same as a physical  time clock. The timestamp is always the server\'s clock, never a client-supplied time;  what the client chooses is the zone: the facility\'s wall-clock time, or (SPD-6157)  the employee\'s own wall-clock time when the optional body carries  OpenShifts.BusinessObjects.Request.Mobile.MobilePunchRequestV2.UtcOffsetMinutes, the client\'s current UTC offset.  A remote employee in Israel who punches at 14:00 Israel time is then recorded at  14:00, not at the facility\'s 07:00, and the time card shows that time without any  conversion. No body and `{}` (what the mobile app sends) keep the facility clock.  The zone is taken at the client\'s word (quarter-hour offsets within UTC-12:00 to  UTC+14:00), so a client that misreports it moves its own punch by that much; the  ticket takes the employee\'s clock as the source. Requires the facility\'s  `EnableAppPunching` configuration  to be on AND the employee to be individually eligible: either the explicit  per-employee app-punching toggle, or (SPD-5774) a punch email on file on the Clock  Info tab, is sufficient for the second part.
         * @param {MobilePunchRequestV2} [mobilePunchRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobilePunchPost(mobilePunchRequestV2?: MobilePunchRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobilePunchResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobilePunchPost(mobilePunchRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * **type** — discriminates the request kind:  | Value | Meaning |  |-------|---------|  | 1 | MissingPunch — employee reported a missing clock-in/out |  | 2 | PunchTimeChange — employee requested a correction to an existing punch |                **status** — current approval state:  | Value | Meaning |  |-------|---------|  | 0 | Pending — awaiting manager review |  | 1 | Accepted — manager approved |  | 2 | Rejected — manager rejected |
         * @summary Returns one page of punch-time-change and missing-punch requests the logged-in  employee has submitted, ordered newest-first (SPD-5408).
         * @param {number} [page] 1-based page number (default 1, min 1).
         * @param {number} [pageSize] Number of items per page (default 20, range 1–100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileRequestHistoryGet(page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeRequestHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileRequestHistoryGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the logged-in employee\'s mobile app settings (SPD-5409): the upcoming-shift  reminder toggle and the reminder lead time in minutes. When the employee has never  saved the screen, reminders default to ENABLED (opt-out) and the lead falls back to  the facility\'s ShiftStartNotificationBeforeMinutes configuration (code default 30).  New settings are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileSettingsResponseV2.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileSettingsResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves the logged-in employee\'s mobile app settings. The payload travels in the mobile  `{\"body\":{...}}` envelope; omitted fields keep their stored values, so a partial  save can never silently reset a sibling setting.
         * @param {UpdateMobileSettingsRequestV2} [updateMobileSettingsRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileSettingsPut(updateMobileSettingsRequestV2?: UpdateMobileSettingsRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileSettingsPut(updateMobileSettingsRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the logged-in employee\'s next upcoming scheduled shift so they know when and  where they work next (SPD-5399). The shape is the same OpenShifts.BusinessObjects.ViewModels.EmployeeSchedulesView  the mobile \"My Shifts\" feature (`GET /employee/v2/work-schedules-in-range`) returns,  so the app reuses its existing shift model. Serves both the V2 and legacy schedulers.  `Location` is null when the facility\'s ShowLocationOnShifts setting is off (SPD-6134).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2MobileUpcomingShiftGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeSchedulesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2MobileUpcomingShiftGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileV2Api - factory interface
 * @export
 */
export const MobileV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the aggregated notification-badge counts for the logged-in employee. Today this is the  count of unresolved \"Missing Punch\" exceptions within the employee\'s currently unclosed pay  periods (closed pay periods are excluded so already-locked history does not keep the badge lit).  New counts are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileNotificationCountsResponseV2  and populated here from their own domain service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileNotificationCountsGet(options?: AxiosRequestConfig): AxiosPromise<MobileNotificationCountsResponseV2> {
            return localVarFp.apiV2MobileNotificationCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *   <b>Date range</b>: when `startDate`/`endDate` are omitted all periods                      for the employee are eligible (subject to pagination). When provided, only periods                      whose date range overlaps the filter are included (period.EndDate >= startDate                      AND period.StartDate <= endDate).    <b>Pagination</b>: `page` is 1-based (default 1); `pageSize` defaults to                      20 and is capped at 100. `TotalCount` in the response reflects the unfiltered                      row count so the caller can derive the total number of pages.    <b>IsLocked</b>: true when the pay period is closed (`IsClosed == true`) or                      any approval level has been recorded for the period. Desktop-held employee locks                      are not checked — mobile self-service callers are not subject to desktop                      concurrency locks.
         * @summary Returns a paginated list of pay periods for the logged-in employee, each including date  range, lock/approval status, missing punch count, and an hours breakdown by pay type  (SPD-5399 pay-period list feature). The breakdown mirrors the pay-period summary view  available on desktop: rows are grouped by pay type and department labor level, ordered  by `PayTypeSortOrder`. Periods are returned newest-first.
         * @param {MobileV2ApiApiV2MobilePayPeriodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobilePayPeriodsGet(requestParameters: MobileV2ApiApiV2MobilePayPeriodsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeePayPeriodListResponse> {
            return localVarFp.apiV2MobilePayPeriodsGet(requestParameters.startDate, requestParameters.endDate, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Records a \"swipe and go\" clock in/out punch for the logged-in employee (SPD-5603) —  no punch type is accepted from the client; the calculation pipeline\'s existing  SwipeAndGo pairing derives in/out/break from the punch sequence, same as a physical  time clock. The timestamp is always the server\'s clock, never a client-supplied time;  what the client chooses is the zone: the facility\'s wall-clock time, or (SPD-6157)  the employee\'s own wall-clock time when the optional body carries  OpenShifts.BusinessObjects.Request.Mobile.MobilePunchRequestV2.UtcOffsetMinutes, the client\'s current UTC offset.  A remote employee in Israel who punches at 14:00 Israel time is then recorded at  14:00, not at the facility\'s 07:00, and the time card shows that time without any  conversion. No body and `{}` (what the mobile app sends) keep the facility clock.  The zone is taken at the client\'s word (quarter-hour offsets within UTC-12:00 to  UTC+14:00), so a client that misreports it moves its own punch by that much; the  ticket takes the employee\'s clock as the source. Requires the facility\'s  `EnableAppPunching` configuration  to be on AND the employee to be individually eligible: either the explicit  per-employee app-punching toggle, or (SPD-5774) a punch email on file on the Clock  Info tab, is sufficient for the second part.
         * @param {MobileV2ApiApiV2MobilePunchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobilePunchPost(requestParameters: MobileV2ApiApiV2MobilePunchPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<MobilePunchResponseV2> {
            return localVarFp.apiV2MobilePunchPost(requestParameters.mobilePunchRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * **type** — discriminates the request kind:  | Value | Meaning |  |-------|---------|  | 1 | MissingPunch — employee reported a missing clock-in/out |  | 2 | PunchTimeChange — employee requested a correction to an existing punch |                **status** — current approval state:  | Value | Meaning |  |-------|---------|  | 0 | Pending — awaiting manager review |  | 1 | Accepted — manager approved |  | 2 | Rejected — manager rejected |
         * @summary Returns one page of punch-time-change and missing-punch requests the logged-in  employee has submitted, ordered newest-first (SPD-5408).
         * @param {MobileV2ApiApiV2MobileRequestHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileRequestHistoryGet(requestParameters: MobileV2ApiApiV2MobileRequestHistoryGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeRequestHistoryResponse> {
            return localVarFp.apiV2MobileRequestHistoryGet(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the logged-in employee\'s mobile app settings (SPD-5409): the upcoming-shift  reminder toggle and the reminder lead time in minutes. When the employee has never  saved the screen, reminders default to ENABLED (opt-out) and the lead falls back to  the facility\'s ShiftStartNotificationBeforeMinutes configuration (code default 30).  New settings are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileSettingsResponseV2.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileSettingsGet(options?: AxiosRequestConfig): AxiosPromise<MobileSettingsResponseV2> {
            return localVarFp.apiV2MobileSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves the logged-in employee\'s mobile app settings. The payload travels in the mobile  `{\"body\":{...}}` envelope; omitted fields keep their stored values, so a partial  save can never silently reset a sibling setting.
         * @param {MobileV2ApiApiV2MobileSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileSettingsPut(requestParameters: MobileV2ApiApiV2MobileSettingsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2MobileSettingsPut(requestParameters.updateMobileSettingsRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the logged-in employee\'s next upcoming scheduled shift so they know when and  where they work next (SPD-5399). The shape is the same OpenShifts.BusinessObjects.ViewModels.EmployeeSchedulesView  the mobile \"My Shifts\" feature (`GET /employee/v2/work-schedules-in-range`) returns,  so the app reuses its existing shift model. Serves both the V2 and legacy schedulers.  `Location` is null when the facility\'s ShowLocationOnShifts setting is off (SPD-6134).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MobileUpcomingShiftGet(options?: AxiosRequestConfig): AxiosPromise<EmployeeSchedulesView> {
            return localVarFp.apiV2MobileUpcomingShiftGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2MobilePayPeriodsGet operation in MobileV2Api.
 * @export
 * @interface MobileV2ApiApiV2MobilePayPeriodsGetRequest
 */
export interface MobileV2ApiApiV2MobilePayPeriodsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MobileV2ApiApiV2MobilePayPeriodsGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof MobileV2ApiApiV2MobilePayPeriodsGet
     */
    readonly endDate?: string

    /**
     * 
     * @type {number}
     * @memberof MobileV2ApiApiV2MobilePayPeriodsGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof MobileV2ApiApiV2MobilePayPeriodsGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiV2MobilePunchPost operation in MobileV2Api.
 * @export
 * @interface MobileV2ApiApiV2MobilePunchPostRequest
 */
export interface MobileV2ApiApiV2MobilePunchPostRequest {
    /**
     * 
     * @type {MobilePunchRequestV2}
     * @memberof MobileV2ApiApiV2MobilePunchPost
     */
    readonly mobilePunchRequestV2?: MobilePunchRequestV2
}

/**
 * Request parameters for apiV2MobileRequestHistoryGet operation in MobileV2Api.
 * @export
 * @interface MobileV2ApiApiV2MobileRequestHistoryGetRequest
 */
export interface MobileV2ApiApiV2MobileRequestHistoryGetRequest {
    /**
     * 1-based page number (default 1, min 1).
     * @type {number}
     * @memberof MobileV2ApiApiV2MobileRequestHistoryGet
     */
    readonly page?: number

    /**
     * Number of items per page (default 20, range 1–100).
     * @type {number}
     * @memberof MobileV2ApiApiV2MobileRequestHistoryGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiV2MobileSettingsPut operation in MobileV2Api.
 * @export
 * @interface MobileV2ApiApiV2MobileSettingsPutRequest
 */
export interface MobileV2ApiApiV2MobileSettingsPutRequest {
    /**
     * 
     * @type {UpdateMobileSettingsRequestV2}
     * @memberof MobileV2ApiApiV2MobileSettingsPut
     */
    readonly updateMobileSettingsRequestV2?: UpdateMobileSettingsRequestV2
}

/**
 * MobileV2Api - object-oriented interface
 * @export
 * @class MobileV2Api
 * @extends {BaseAPI}
 */
export class MobileV2Api extends BaseAPI {
    /**
     * 
     * @summary Returns the aggregated notification-badge counts for the logged-in employee. Today this is the  count of unresolved \"Missing Punch\" exceptions within the employee\'s currently unclosed pay  periods (closed pay periods are excluded so already-locked history does not keep the badge lit).  New counts are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileNotificationCountsResponseV2  and populated here from their own domain service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobileNotificationCountsGet(options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobileNotificationCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *   <b>Date range</b>: when `startDate`/`endDate` are omitted all periods                      for the employee are eligible (subject to pagination). When provided, only periods                      whose date range overlaps the filter are included (period.EndDate >= startDate                      AND period.StartDate <= endDate).    <b>Pagination</b>: `page` is 1-based (default 1); `pageSize` defaults to                      20 and is capped at 100. `TotalCount` in the response reflects the unfiltered                      row count so the caller can derive the total number of pages.    <b>IsLocked</b>: true when the pay period is closed (`IsClosed == true`) or                      any approval level has been recorded for the period. Desktop-held employee locks                      are not checked — mobile self-service callers are not subject to desktop                      concurrency locks.
     * @summary Returns a paginated list of pay periods for the logged-in employee, each including date  range, lock/approval status, missing punch count, and an hours breakdown by pay type  (SPD-5399 pay-period list feature). The breakdown mirrors the pay-period summary view  available on desktop: rows are grouped by pay type and department labor level, ordered  by `PayTypeSortOrder`. Periods are returned newest-first.
     * @param {MobileV2ApiApiV2MobilePayPeriodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobilePayPeriodsGet(requestParameters: MobileV2ApiApiV2MobilePayPeriodsGetRequest = {}, options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobilePayPeriodsGet(requestParameters.startDate, requestParameters.endDate, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Records a \"swipe and go\" clock in/out punch for the logged-in employee (SPD-5603) —  no punch type is accepted from the client; the calculation pipeline\'s existing  SwipeAndGo pairing derives in/out/break from the punch sequence, same as a physical  time clock. The timestamp is always the server\'s clock, never a client-supplied time;  what the client chooses is the zone: the facility\'s wall-clock time, or (SPD-6157)  the employee\'s own wall-clock time when the optional body carries  OpenShifts.BusinessObjects.Request.Mobile.MobilePunchRequestV2.UtcOffsetMinutes, the client\'s current UTC offset.  A remote employee in Israel who punches at 14:00 Israel time is then recorded at  14:00, not at the facility\'s 07:00, and the time card shows that time without any  conversion. No body and `{}` (what the mobile app sends) keep the facility clock.  The zone is taken at the client\'s word (quarter-hour offsets within UTC-12:00 to  UTC+14:00), so a client that misreports it moves its own punch by that much; the  ticket takes the employee\'s clock as the source. Requires the facility\'s  `EnableAppPunching` configuration  to be on AND the employee to be individually eligible: either the explicit  per-employee app-punching toggle, or (SPD-5774) a punch email on file on the Clock  Info tab, is sufficient for the second part.
     * @param {MobileV2ApiApiV2MobilePunchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobilePunchPost(requestParameters: MobileV2ApiApiV2MobilePunchPostRequest = {}, options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobilePunchPost(requestParameters.mobilePunchRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **type** — discriminates the request kind:  | Value | Meaning |  |-------|---------|  | 1 | MissingPunch — employee reported a missing clock-in/out |  | 2 | PunchTimeChange — employee requested a correction to an existing punch |                **status** — current approval state:  | Value | Meaning |  |-------|---------|  | 0 | Pending — awaiting manager review |  | 1 | Accepted — manager approved |  | 2 | Rejected — manager rejected |
     * @summary Returns one page of punch-time-change and missing-punch requests the logged-in  employee has submitted, ordered newest-first (SPD-5408).
     * @param {MobileV2ApiApiV2MobileRequestHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobileRequestHistoryGet(requestParameters: MobileV2ApiApiV2MobileRequestHistoryGetRequest = {}, options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobileRequestHistoryGet(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the logged-in employee\'s mobile app settings (SPD-5409): the upcoming-shift  reminder toggle and the reminder lead time in minutes. When the employee has never  saved the screen, reminders default to ENABLED (opt-out) and the lead falls back to  the facility\'s ShiftStartNotificationBeforeMinutes configuration (code default 30).  New settings are added as additional fields on OpenShifts.BusinessObjects.Response.Mobile.MobileSettingsResponseV2.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobileSettingsGet(options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobileSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves the logged-in employee\'s mobile app settings. The payload travels in the mobile  `{\"body\":{...}}` envelope; omitted fields keep their stored values, so a partial  save can never silently reset a sibling setting.
     * @param {MobileV2ApiApiV2MobileSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobileSettingsPut(requestParameters: MobileV2ApiApiV2MobileSettingsPutRequest = {}, options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobileSettingsPut(requestParameters.updateMobileSettingsRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the logged-in employee\'s next upcoming scheduled shift so they know when and  where they work next (SPD-5399). The shape is the same OpenShifts.BusinessObjects.ViewModels.EmployeeSchedulesView  the mobile \"My Shifts\" feature (`GET /employee/v2/work-schedules-in-range`) returns,  so the app reuses its existing shift model. Serves both the V2 and legacy schedulers.  `Location` is null when the facility\'s ShowLocationOnShifts setting is off (SPD-6134).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileV2Api
     */
    public apiV2MobileUpcomingShiftGet(options?: AxiosRequestConfig) {
        return MobileV2ApiFp(this.configuration).apiV2MobileUpcomingShiftGet(options).then((request) => request(this.axios, this.basePath));
    }
}
